import React, { useState, useEffect  } from 'react';
import { Modal, ModalBody, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import backlogo from '../../Assets/App_icon/back.png';
import insertlogo from '../../Assets/App_icon/insert.png';

const ProductMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 

  const [PLData, setPLData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [opstock, setOpStock] = useState(null);
  
  const handleBack = () => {
    navigate('../dashboard');
  };

    // Escape key press handling
    useEffect(() => {
        const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible)  {
              setModalVisible(false);
          } else {
            handleBack();
          }
        }
        
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible]);

    
    useEffect(() => { 
      const fetchPLData = async () => { 
          try {
            const response = await fetch(`${host_url}/PL_Data`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
              }),
            });
            
            const data = await response.json();
            console.log(data);
            setPLData(data);
          } catch (error) {
            console.error('Error fetching PL Data:', error);
          }
      }; 
     fetchPLData(); 
    }, [host_url]); // PL DAta Fetch

    const [monthFilter, setMonthFilter] = useState('');
    const [yearFilter, setYearFilter] = useState('');
    
    const totalCount = PLData.length;
    const tot_profit = PLData.reduce((sum, row) => sum + Number(row.profit), 0);
    const tot_stock = PLData.reduce((sum, row) => sum + Number(row.stock), 0);
    const tot_sales = PLData.reduce((sum, row) => sum + Number(row.sales), 0);
    const tot_pur = PLData.reduce((sum, row) => sum + Number(row.pur), 0);
    const tot_wastage = PLData.reduce((sum, row) => sum + Number(row.wastage), 0);
    const tot_exp = PLData.reduce((sum, row) => sum + Number(row.exp), 0);


    // Handle row click
    const handleRowClick = (row, index) => {
      setOpStock(index === 0 ? 0 : PLData[index - 1].stock);
      console.log(row);
      setSelectedRow(row);
      setModalVisible(true); 
    };

     // Handle row click
    const handleInsertClick = async () => {
      setSelectedRow(null);
      setOpStock(PLData[PLData.length - 1].stock);
      try {
            const response = await fetch(`${host_url}/PL_Data`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'live',
                store: store,
              }),
            });
            
            const data = await response.json();
            console.log(data);
            setSelectedRow(data[0]);
            setModalVisible(true); 
          } catch (error) {
            console.error('Error fetching PL Data:', error);
          }
      
    };


  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>P/L Report</b>
              <div onClick={handleInsertClick}>
                <img src={insertlogo} alt="Back" className='system-icon'/>
              </div>
          </div> 
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th className="cell-left" >Month</th>
                <th className="cell-right">Sales</th>
                <th className="cell-right">Profit</th>
                <th className="cell-right">P/S Ratio</th>

              </tr>
            </thead>
            <tbody className="scrollable-body">
              {PLData.map((row, index) => {
                  return (
                    <tr key={index} style={{ lineHeight: '10px', fontSize:'14px', cursor: 'pointer' }}  onClick={() => handleRowClick(row, index)}>
                      <td className="cell-left" >{row.month }</td>
                      <td className="cell-right" >{row.sales }</td>
                      <td className="cell-right" >{row.profit }</td>
                      <td className="cell-right" >{row.profit !== 0 ? ((row.profit / row.sales) * 100).toFixed(2) : '0.00'}</td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left" ><span style={{ paddingLeft: '10px' }}>{totalCount}</span></th>
                <th className="cell-right">{tot_sales}</th>
                <th className="cell-right">{tot_profit}</th>
                <th className="cell-right"><span style={{ paddingRight: '5px' }}>{tot_profit !== 0 ? ((tot_profit / tot_sales) * 100).toFixed(2) : '0.00'}</span></th>
              </tr>
            </tfoot>
          </table>
          
          {/* Modal for PL Data Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                {selectedRow && (
                  <div>
                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div> </div>
                            <div><h6>{selectedRow.month}</h6></div>
                            <div>
                              <Button color="primary" style={{ padding: '2px 10px', margin: '2px', width: '100%' }} onClick={() => setModalVisible(false)}>
                                Close
                              </Button>
                            </div>
                          </div>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th colSpan='2' className="cell-right" style={{ padding: '2px', paddingRight: '15px', fontSize: '12px' }}>Amt</th>
                          <th colSpan='2' className="cell-right" style={{ padding: '2px', paddingRight: '5px', fontSize: '12px' }}>Amt</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        <tr>
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>CL Stock</td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '15px', fontSize: '14px' }}>{selectedRow.stock}</td>
                          
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '15px', fontSize: '14px' }}>OP Stock</td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '5px', fontSize: '14px' }}>{opstock}</td>
                        </tr>
                        <tr>
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>Sales</td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '15px', fontSize: '14px' }}>{selectedRow.sales}</td>
                          
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '15px', fontSize: '14px' }}>Purchase</td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '5px', fontSize: '14px' }}>{selectedRow.pur}</td>
                        </tr>
                        <tr>
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}></td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '15px', fontSize: '14px' }}></td>
                          
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '15px', fontSize: '14px' }}>Wastage</td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '5px', fontSize: '14px' }}>{selectedRow.wastage}</td>
                        </tr>
                        <tr>
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}></td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '15px', fontSize: '14px' }}></td>
                          
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '15px', fontSize: '14px' }}>Expances</td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '5px', fontSize: '14px' }}>{selectedRow.exp}</td>
                        </tr>

                        <tr>
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}></td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '15px', fontSize: '14px' }}></td>
                          
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '15px', fontSize: '14px', fontWeight: 'bold' }}></td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '5px', fontSize: '14px', fontWeight: 'bold' }}></td>
                        </tr>
                        <tr>
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}></td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '15px', fontSize: '14px' }}></td>
                          
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '15px', fontSize: '14px', fontWeight: 'bold' }}>
                            <span style={{ color: selectedRow.profit < 0 ? 'red' : '#41833a' }}>{selectedRow.profit < 0 ? 'Loss' : 'Profit'}</span>
                          </td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '5px', fontSize: '14px', fontWeight: 'bold' }}>
                            <span style={{ color: selectedRow.profit < 0 ? 'red' : '#41833a' }}>{selectedRow.profit}</span>
                          </td>
                        </tr>

                        <tr>
                          <th className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}></th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '15px', fontSize: '14px',  fontWeight: 'bold' }}>
                            {selectedRow.stock + selectedRow.sales }
                          </th>
                          
                          <th className="cell-left" style={{ padding: '2px', paddingLeft: '15px', fontSize: '14px' }}></th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '5px', fontSize: '14px',  fontWeight: 'bold' }}>
                            { opstock + selectedRow.pur +selectedRow.wastage + selectedRow.exp + selectedRow.profit }
                          </th>
                        </tr>


                        <tr>
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}></td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '15px', fontSize: '14px' }}></td>
                          
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '15px', fontSize: '14px', fontWeight: 'bold' }}></td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '5px', fontSize: '14px', fontWeight: 'bold' }}> &nbsp;</td>
                        </tr>
                        <tr>
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>Due Payment</td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '15px', fontSize: '14px' }}>{selectedRow.due_pay}</td>
                          
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '15px', fontSize: '14px' }}>Cash_Bank</td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '5px', fontSize: '14px' }}>{selectedRow.cb_balance}</td>
                        </tr>
                        <tr>
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>Cust Advance</td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '15px', fontSize: '14px' }}>{selectedRow.cust_adv}</td>
                          
                          <td className="cell-left" style={{ padding: '2px', paddingLeft: '15px', fontSize: '14px' }}>Del Balance</td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '5px', fontSize: '14px' }}>{selectedRow.del_balance}</td>
                        </tr>
                        

                        <tr>
                          <th className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}></th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '15px', fontSize: '14px',  fontWeight: 'bold' }}>
                            {selectedRow.due_pay + selectedRow.cust_adv}
                          </th>
                          
                          <th className="cell-left" style={{ padding: '2px', paddingLeft: '15px', fontSize: '14px' }}></th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '5px', fontSize: '14px',  fontWeight: 'bold' }}>
                            {selectedRow.cb_balance + selectedRow.del_balance}
                          </th>
                        </tr>

                      </tbody>

                    </table>

                  </div>
                )}

              </ModalBody>
            </Modal>

    </div>
  );
};

export default ProductMaster;
